// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"92722d82","453":"e4009fa8"}[chunkId] + ".chunk.js";
};